import type { ComponentType } from 'react';
import { Loading as Loader } from '@kiwicom/account-components';

const Loading = () => <Loader dataTest="QueryRenderLoader" />;

export default Loading as ComponentType<Record<string, never>>;
